import type {Result, UseCase} from 'framework';
import type {ActiveScheduleWorkout} from '../../domain/active-schedule-workout';
import type {ScheduleError} from '../../domain/errors';
import type {ScheduleRepository} from '../ports/schedule.repository';

export class GetActiveScheduleWorkout implements UseCase<[], ActiveScheduleWorkout | null> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(): Promise<Result<ActiveScheduleWorkout | null, ScheduleError>> {
    return this.repository.getActiveWorkout();
  }
}
